/* GeoDomeX — Figma PDP build · shared behaviour (preview + Shopify asset figma-pdp.js)
   Preview fallbacks below; the Shopify build injects variant ids/prices via data attributes/JSON. */
(function () {
  "use strict";
  /* re-entry guard: Shopify section:load / theme-editor re-evals must not
     double-bind carousels, accordions, hotspots and observers */
  if (window.__fxPdpBound) return;
  window.__fxPdpBound = true;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var FXsrc = function (p) { return (window.FXIMG && window.FXIMG[p]) || p; };
  if (window.FXIMG) { $$("img[data-fx]").forEach(function (i) { i.src = FXsrc(i.getAttribute("data-fx")); }); }

  /* ---------- generic carousels (dots + arrows) ---------- */
  $$(".fx-nav[data-for]").forEach(function (nav) {
    var track = document.getElementById(nav.dataset.for);
    if (!track) return;
    var prev = $(".prev", nav), next = $(".next", nav), dots = $(".fx-dots", nav);
    var cards = $$(":scope > *", track);
    function cardW() { var c = cards[0]; return c ? c.getBoundingClientRect().width + 16 : 320; }
    function renderDots() {
      nav.classList.toggle("is-idle", track.scrollWidth <= track.clientWidth + 1);
      if (!dots) return;
      var pages = Math.max(1, Math.round((track.scrollWidth - track.clientWidth) / cardW()) + 1);
      var n = Math.min(pages, 8), cur = Math.round(track.scrollLeft / cardW());
      dots.innerHTML = "";
      for (var i = 0; i < n; i++) { var d = document.createElement("span"); if (i === Math.min(cur, n - 1)) d.className = "on"; dots.appendChild(d); }
    }
    prev && prev.addEventListener("click", function () { track.scrollBy({ left: -cardW(), behavior: "smooth" }); });
    next && next.addEventListener("click", function () { track.scrollBy({ left: cardW(), behavior: "smooth" }); });
    track.addEventListener("scroll", function () { window.requestAnimationFrame(renderDots); });
    window.addEventListener("resize", renderDots);
    renderDots();
  });

  /* ---------- accordions (manual open/close always allowed) ---------- */
  $$(".fx-stepwrap, .fx-qa").forEach(function (item) {
    var head = $(":scope > button", item);
    if (!head) return;
    head.addEventListener("click", function () {
      var open = item.classList.toggle("open");
      head.setAttribute("aria-expanded", open ? "true" : "false");
    });
  });
  function openStep(id) {
    var el = document.getElementById(id);
    if (el && !el.classList.contains("open")) {
      el.classList.add("open");
      var head = $(":scope > button", el);
      if (head) head.setAttribute("aria-expanded", "true");
    }
  }

  /* size tabs (sizes section) — one open at a time */
  $$(".fx-sizes .fx-sizetab").forEach(function (tab) {
    var head = $(":scope > button", tab);
    if (!head) return;
    head.addEventListener("click", function () {
      var was = tab.classList.contains("open");
      $$(".fx-sizes .fx-sizetab").forEach(function (t) { t.classList.remove("open"); var hb = $(":scope > button", t); if (hb) hb.setAttribute("aria-expanded", "false"); });
      if (!was) { tab.classList.add("open"); head.setAttribute("aria-expanded", "true"); }
    });
  });

  /* ---------- weather hotspots: tap toggles ---------- */
  $$(".fx-hotspot").forEach(function (h) {
    h.addEventListener("click", function (e) {
      e.preventDefault();
      var was = h.classList.contains("open");
      $$(".fx-hotspot").forEach(function (x) { x.classList.remove("open"); });
      if (!was) h.classList.add("open");
    });
  });

  /* ---------- toast ---------- */
  var toastT = null;
  function toast(html) {
    var el = $("#fx-toast"); if (!el) return;
    el.innerHTML = html; el.classList.add("show");
    if (toastT) clearTimeout(toastT);
    toastT = setTimeout(function () { el.classList.remove("show"); }, 3200);
  }

  /* ---------- before/after slider (drag + keyboard) ---------- */
  var ba = $("#fx-ba") || $(".fx-ba");
  if (ba) {
    var knob = $(".knob", ba);
    var setPos = function (pct) {
      pct = Math.max(10, Math.min(90, pct));
      ba.style.setProperty("--pos", pct + "%");
      if (knob) knob.setAttribute("aria-valuenow", Math.round(pct));
    };
    var fromEvent = function (e) {
      var r = ba.getBoundingClientRect();
      var x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left;
      setPos((x / r.width) * 100);
    };
    var dragging = false;
    ba.addEventListener("pointerdown", function (e) { dragging = true; try { ba.setPointerCapture(e.pointerId); } catch (err) {} fromEvent(e); });
    ba.addEventListener("pointermove", function (e) { if (dragging) fromEvent(e); });
    ba.addEventListener("pointerup", function () { dragging = false; });
    ba.addEventListener("pointercancel", function () { dragging = false; });
    if (knob) {
      knob.addEventListener("keydown", function (e) {
        var cur = parseFloat(getComputedStyle(ba).getPropertyValue("--pos")) || 50;
        if (e.key === "ArrowLeft") { setPos(cur - 4); e.preventDefault(); }
        if (e.key === "ArrowRight") { setPos(cur + 4); e.preventDefault(); }
      });
    }
    setPos(50);
  }

  /* ---------- imagine panel rotation ---------- */
  var imagineData = $("[data-imagine-slides]");
  var IMAGINE = [];
  if (imagineData) { try { IMAGINE = JSON.parse(imagineData.textContent); } catch (e) { IMAGINE = []; } }
  else {
    IMAGINE = [
      { l: "img/fx-lounge.jpg", lc: "A <b>private lounge</b> under the sky.", r: "img/fx-imagine.jpg", rc: "<b>200x stronger than glass</b> with crystal-clear transparency" },
      { l: "img/fx-netflix.jpg", lc: "", r: "img/fx-dusk.jpg", rc: "" },
      { l: "img/fx-firepit.jpg", lc: "", r: "img/fx-nightdog.jpg", rc: "" }
    ];
  }
  var imIdx = 0;
  $$("[data-imagine]").forEach(function (b) {
    if (IMAGINE.length < 2) { var nv = b.closest(".fx-nav"); (nv || b).style.display = "none"; return; }
    b.addEventListener("click", function () {
      if (!IMAGINE.length) return;
      imIdx = (imIdx + parseInt(b.dataset.imagine, 10) + IMAGINE.length) % IMAGINE.length;
      var s = IMAGINE[imIdx];
      var phs = $$(".fx-imagine .ph");
      if (phs.length === 2) {
        $("img", phs[0]).src = FXsrc(s.l); $(".cap", phs[0]).innerHTML = s.lc || "";
        $("img", phs[1]).src = FXsrc(s.r); $(".cap", phs[1]).innerHTML = s.rc || "";
      }
    });
  });

  /* ================= BUY BOX — progressive 4-step flow ================= */
  /* Preview fallback = the live tier-product matrix (size × tier). The theme injects its own map. */
  var mapData = $("[data-variant-map]");
  var PRICEMAP = null;
  if (mapData) { try { PRICEMAP = JSON.parse(mapData.textContent); } catch (e) { PRICEMAP = null; } }
  var listData = $("[data-variant-list]");
  if (!PRICEMAP && listData) {
    try {
      var list = JSON.parse(listData.textContent);
      PRICEMAP = {};
      list.forEach(function (v) {
        var t = v.t || "default";
        if (!PRICEMAP[v.s]) PRICEMAP[v.s] = {};
        PRICEMAP[v.s][t] = { id: v.id, f: v.f };
      });
    } catch (e) { PRICEMAP = null; }
  }
  if (!PRICEMAP) {
    PRICEMAP = {
      mini:     { original: { p: 899,  f: "£899" },   ultra: { p: 1299, f: "£1,299" }, extreme: { p: 1999, f: "£1,999" } },
      standard: { original: { p: 997,  f: "£997" },   ultra: { p: 1499, f: "£1,499" }, extreme: { p: 2499, f: "£2,499" } },
      large:    { original: { p: 3499, f: "£3,499" }, ultra: { p: 3999, f: "£3,999" }, extreme: { p: 4999, f: "£4,999" } }
    };
  }
  var SIZE_NAME = { mini: "Mini", standard: "Standard", large: "Large" };
  var TIER_NAME = { original: "Original", ultra: "Ultra", extreme: "Extreme", default: "" };
  var SPECS = {
    mini: '<span>↔ <b>Ø</b> 8.9ft (2.7m)</span><span>👤 <b>Seats</b> 4-6</span><span>⏱ <b>Build:</b> 3-4 Hours</span>',
    standard: '<span>↔ <b>Ø</b> 11.6ft (3.5m)</span><span>↕ <b>H</b> 6.8ft (2.1m)</span><span>▦ ~103 sq ft</span><span>👤 <b>Seats</b> 6-8</span><span>⏱ <b>Build:</b> 4-6 Hours</span>',
    large: '<span>↔ <b>Ø</b> 16.4ft (5.0m)</span><span>👤 <b>Seats</b> 12-16</span>'
  };
  var state = { size: "standard", tier: null, qty: 1 };
  var pcCovered = false;

  function sizeName(k) { var o = $$(".fx-sizeopt").filter(function (x) { return x.dataset.size === k; })[0]; return (o && o.dataset.addonName) || SIZE_NAME[k] || k; }
  function tierData(size, tier) { return (PRICEMAP[size] && PRICEMAP[size][tier]) || null; }

  function renderBuy() {
    $$(".fx-sizeopt").forEach(function (o) { o.classList.toggle("sel", o.dataset.size === state.size); });
    $$(".fx-tieropt").forEach(function (o) {
      o.classList.toggle("sel", o.dataset.tier === state.tier);
      var pr = $("[data-tier-price]", o) || $(".pr", o);
      var d = tierData(state.size, o.dataset.tier);
      if (pr && d) pr.textContent = d.f;
    });
    var sl = $("#spec-line"); if (sl && SPECS[state.size]) sl.innerHTML = SPECS[state.size];
    $$("[data-addon-size]").forEach(function (el) { el.textContent = sizeName(state.size); });

    /* assembly row: included with Extreme */
    var asmRow = $$(".fx-addon").filter(function (r) { return $("#pc-in", r); })[0];
    if (asmRow) {
      var t = $(".fx-toggle", asmRow);
      if (state.tier === "extreme") {
        asmRow.classList.add("locked"); asmRow.classList.remove("sel");
        if (t) t.setAttribute("aria-pressed", "false");
        var msg = $("#pc-msg"); if (msg) { msg.className = "msg ok"; msg.textContent = "Professional assembly is already included with the Extreme tier."; }
      } else if (asmRow.classList.contains("locked")) {
        asmRow.classList.remove("locked");
        var msg2 = $("#pc-msg"); if (msg2 && msg2.textContent.indexOf("Extreme") > -1) { msg2.textContent = ""; }
      }
    }

    /* step 4 summary + price + atc */
    var d = state.tier ? tierData(state.size, state.tier) : null;
    var q = $("#qty-num"); if (q) q.textContent = (state.qty < 10 ? "0" : "") + state.qty;
    var sum = $("#sum-line");
    var tn = state.tier ? (TIER_NAME[state.tier] !== undefined ? TIER_NAME[state.tier] : state.tier) : "";
    if (sum) sum.textContent = "GeoDomeX " + sizeName(state.size) + (tn ? " · " + tn : "");
    var extras = $$('.fx-addon .fx-toggle[aria-pressed="true"]').length;
    var sa = $("#sum-addons"); if (sa) sa.textContent = extras ? ("+ " + extras + " add-on" + (extras > 1 ? "s" : "")) : "";
    var p = $("#buy-price");
    if (p) p.textContent = d ? (state.qty > 1 ? d.f + " × " + state.qty : d.f) : "—";
    var atc = $("#atc"), hint = $("#atc-hint");
    if (atc) atc.disabled = !d;
    if (hint) hint.hidden = !!d;
  }

  /* step 1: size select -> open step 2 (products without a tier option skip straight to 3+4) */
  $$(".fx-sizeopt").forEach(function (o) {
    o.addEventListener("click", function () {
      state.size = o.dataset.size;
      var tiers = PRICEMAP[state.size] ? Object.keys(PRICEMAP[state.size]) : [];
      if (tiers.length === 1 && tiers[0] === "default") {
        state.tier = "default";
        openStep("step-specs"); openStep("step-addons"); openStep("step-checkout");
      } else {
        openStep("step-specs");
      }
      renderBuy();
    });
  });
  /* step 2: tier select -> open steps 3 + 4 */
  $$(".fx-tieropt").forEach(function (o) {
    o.addEventListener("click", function () {
      state.tier = o.dataset.tier;
      openStep("step-addons");
      openStep("step-checkout");
      renderBuy();
    });
  });
  var qm = $("#qty-minus"), qp = $("#qty-plus");
  qm && qm.addEventListener("click", function () { state.qty = Math.max(1, state.qty - 1); renderBuy(); });
  qp && qp.addEventListener("click", function () { state.qty = Math.min(9, state.qty + 1); renderBuy(); });

  /* add-on toggles (assembly gated by postcode coverage + Extreme lock) */
  $$(".fx-addon").forEach(function (row) {
    var t = $(".fx-toggle", row);
    var isAssembly = !!$("#pc-in", row);
    t && t.addEventListener("click", function () {
      if (row.classList.contains("locked")) { toast("Professional assembly is <b>included with Extreme</b> — nothing to add."); return; }
      var turningOn = t.getAttribute("aria-pressed") !== "true";
      if (isAssembly && turningOn && !pcCovered) {
        var msg = $("#pc-msg");
        if (msg) { msg.className = "msg err"; msg.textContent = "Enter your postcode above to check assembly coverage first."; }
        var inp = $("#pc-in"); if (inp) inp.focus();
        return;
      }
      t.setAttribute("aria-pressed", turningOn ? "true" : "false");
      row.classList.toggle("sel", turningOn);
      renderBuy();
    });
  });

  /* postcode availability (assembly coverage: England & Wales mainland) */
  var PC_RE = /^([A-Z]{1,2}\d[A-Z\d]?)\s*\d[A-Z]{2}$/i;
  var PC_EXCL = /^(AB|DD|DG|EH|FK|G|HS|IV|KA|KW|KY|ML|PA|PH|TD|ZE|BT|IM|JE|GY)\d/i;
  var pcIn = $("#pc-in"), pcMsg = $("#pc-msg");
  function checkPc() {
    var v = pcIn.value.trim().toUpperCase();
    pcCovered = false;
    if (!v) { pcMsg.textContent = ""; return; }
    var m = v.match(PC_RE);
    if (!m) { pcMsg.className = "msg err"; pcMsg.textContent = "That doesn't look like a UK postcode — try AB12 3CD format"; return; }
    var out = m[1];
    if (PC_EXCL.test(v) || /^TR2[1-5]$/.test(out)) {
      pcMsg.className = "msg err";
      pcMsg.textContent = "Assembly isn't available in your area yet — currently England & Wales mainland only.";
    } else {
      pcCovered = true;
      pcMsg.className = "msg ok";
      pcMsg.textContent = "✓ Good news — assembly is available in " + out + ". Toggle it on to add.";
    }
  }
  if (pcIn) {
    pcIn.addEventListener("change", checkPc);
    pcIn.addEventListener("input", function () { if (!pcIn.value.trim()) { pcCovered = false; pcMsg.textContent = ""; } });
    pcIn.addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); checkPc(); } });
  }

  /* add to cart — preview: toast · theme: /cart/add.js via injected variant ids */
  var atcBtn = $("#atc");
  atcBtn && atcBtn.addEventListener("click", function () {
    var d = state.tier ? tierData(state.size, state.tier) : null;
    if (!d) { openStep("step-specs"); toast("Pick a <b>specification tier</b> in Step 2 first."); return; }
    if (d.id) {
      var items = [{ id: parseInt(d.id, 10), quantity: state.qty }];
      $$(".fx-addon").forEach(function (row) {
        var t = $(".fx-toggle", row);
        if (t && t.getAttribute("aria-pressed") === "true" && row.dataset.variantId) items.push({ id: parseInt(row.dataset.variantId, 10), quantity: 1 });
      });
      atcBtn.disabled = true;
      fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw new Error("cart"); return r.json(); })
        .then(function () { toast("<b>Added to cart ✓</b>"); window.setTimeout(function () { window.location.href = "/cart"; }, 650); })
        .catch(function () { toast("Couldn't add to cart — please try again"); })
        .finally(function () { atcBtn.disabled = false; });
    } else {
      var extras = $$('.fx-addon .fx-toggle[aria-pressed="true"]').length;
      toast("<b>Added to cart ✓</b> &nbsp;GeoDomeX " + sizeName(state.size) + " · " + TIER_NAME[state.tier] + " × " + state.qty + (extras ? " + " + extras + " add-on" + (extras > 1 ? "s" : "") : ""));
    }
  });

  /* ---------- product gallery ---------- */
  var galData = $("[data-gallery-images]");
  var GAL = [];
  if (galData) { try { GAL = JSON.parse(galData.textContent); } catch (e) { GAL = []; } }
  if (!GAL.length) GAL = ["img/fx-gallery1.jpg", "img/fx-dusk2.jpg", "img/fx-after.jpg", "img/fx-lounge.jpg", "img/fx-netflix.jpg", "img/fx-firepit.jpg"];
  var gIdx = 0, gMain = $("#gal-main"), gThumbs = $("#gal-thumbs"), gDots = $(".fx-gallery .gdots");
  function renderGal() {
    if (!gMain) return;
    gMain.src = FXsrc(GAL[gIdx]);
    $$("button", gThumbs).forEach(function (b, i) { b.classList.toggle("on", i === gIdx); });
    if (gDots) { gDots.innerHTML = ""; GAL.forEach(function (_, i) { var d = document.createElement("span"); if (i === gIdx) d.className = "on"; gDots.appendChild(d); }); }
  }
  if (gThumbs) {
    GAL.forEach(function (src, i) {
      var b = document.createElement("button"); b.type = "button"; b.setAttribute("aria-label", "Image " + (i + 1));
      var im = document.createElement("img"); im.src = FXsrc(src); im.alt = ""; im.loading = "lazy";
      b.appendChild(im); b.addEventListener("click", function () { gIdx = i; renderGal(); });
      gThumbs.appendChild(b);
    });
    var gp = $(".fx-gallery .gnav.p"), gn = $(".fx-gallery .gnav.n");
    gp && gp.addEventListener("click", function () { gIdx = (gIdx - 1 + GAL.length) % GAL.length; renderGal(); });
    gn && gn.addEventListener("click", function () { gIdx = (gIdx + 1) % GAL.length; renderGal(); });
    renderGal();
  }

  /* ---------- video slots (play buttons; the outro bg video autoplays and is excluded) ---------- */
  $$(".fx-play, [data-video]").forEach(function (v) {
    v.addEventListener("click", function (e) {
      e.preventDefault(); e.stopPropagation();
      var host = v.closest("[data-video-url]");
      var url = (host && host.dataset.videoUrl) || v.dataset.videoUrl;
      if (url) {
        var wrap = document.createElement("div");
        wrap.style.cssText = "position:fixed;inset:0;z-index:99;background:rgba(10,9,8,.88);display:flex;align-items:center;justify-content:center;padding:4vw";
        /* portrait phone footage letterboxes to a quarter of a 16:9 frame - size the
           box to the video's orientation instead (gdx_portrait=1 marks portrait embeds;
           mp4s report their real shape via loadedmetadata) */
        var portrait = /[?&]gdx_portrait=1/.test(url);
        /* start with sound: the click is a user gesture, and allow="autoplay" delegates
           it into the iframe - without an explicit muted=0 Vimeo assumes muted autoplay */
        if (/vimeo/.test(url) && !/[?&]muted=/.test(url)) url += (url.indexOf('?') > -1 ? '&' : '?') + 'muted=0';
        var pBox = 'width:min(92vw,calc(min(86vh,800px)*9/16));aspect-ratio:9/16;';
        var inner = /youtube|youtu\.be|vimeo/.test(url)
          ? '<iframe src="' + url + '" style="' + (portrait ? pBox : 'width:min(92vw,1000px);aspect-ratio:16/9;') + 'border:0" allow="autoplay; fullscreen" allowfullscreen></iframe>'
          : '<video src="' + url + '" style="width:min(92vw,1000px);max-height:86vh" controls autoplay playsinline></video>';
        wrap.innerHTML = inner + '<button aria-label="Close" style="position:absolute;top:18px;right:22px;background:none;border:0;color:#fff;font-size:30px;cursor:pointer">✕</button>';
        wrap.addEventListener("click", function (ev) { if (ev.target === wrap || ev.target.tagName === "BUTTON") wrap.remove(); });
        var vidEl = wrap.querySelector('video');
        if (vidEl) vidEl.addEventListener('loadedmetadata', function () {
          if (vidEl.videoHeight > vidEl.videoWidth) vidEl.style.cssText = 'width:min(92vw,calc(min(86vh,800px)*9/16));aspect-ratio:9/16';
        });
        document.body.appendChild(wrap);
      } else {
        toast("▶ <b>Video slot</b> — the file is wired per-section in the Shopify theme editor");
      }
    });
  });

  /* outro background video: defer the download until it approaches the viewport, then autoplay (muted) */
  var bgvid = $(".fx-transformed video");
  /* poster-only for users who asked for less motion or less data — the 9.5MB
     download only makes sense when neither preference objects */
  if (bgvid && (window.matchMedia("(prefers-reduced-motion: reduce)").matches ||
      (navigator.connection && navigator.connection.saveData))) bgvid = null;
  if (bgvid) {
    var bgWanted = false;
    var tryPlay = function () { bgWanted = true; var p = bgvid.play(); if (p && p.catch) p.catch(function () {}); };
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (es) {
        if (es[es.length - 1].isIntersecting) tryPlay();
      }, { rootMargin: "700px 0px" }).observe(bgvid);
    } else { tryPlay(); }
    document.addEventListener("pointerdown", function () { if (bgWanted) tryPlay(); }, { once: true });
  }

  /* scroll-reveal (progressive enhancement — .fx-io gates all hiding, so no-JS renders everything) */
  if ("IntersectionObserver" in window && window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
    document.documentElement.classList.add("fx-io");
    var revSel = [
      ".fx-press p", ".fx-tcard",
      ".fx-delivery .grid>*",
      ".fx-weather .hd", ".fx-diagram", ".fx-wcard",
      ".fx-simple .fx-wrap>*",
      ".fx-details .grid>*", ".fx-sizes .grid>*",
      ".fx-transform .fx-h2", ".fx-transform .fx-rating", ".fx-ba-row", ".fx-transform .cap",
      ".fx-imagine .panels>*",
      ".fx-reviews .fx-wrap", ".fx-rcard",
      ".fx-faq .grid>*",
      ".fx-transformed .caption", ".fx-igcard", ".fx-igrow .tile",
      ".fxw-vcard", ".fxw-card", ".fxw-tcard", ".fxw-h2"
    ].join(",");
    var revEls = $$(revSel);
    revEls.forEach(function (el) {
      el.classList.add("fx-rev");
      var sibs = Array.prototype.filter.call(el.parentElement.children, function (c) { return c.classList.contains("fx-rev"); });
      var k = sibs.indexOf(el);
      if (k > 0) el.style.transitionDelay = (Math.min(k, 4) * 0.07) + "s";
    });
    var revIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add("in"); revIO.unobserve(en.target); }
      });
    }, { rootMargin: "0px 0px -7% 0px", threshold: 0.05 });
    revEls.forEach(function (el) { revIO.observe(el); });
  }

  renderBuy();
})();

/* gdx scroll assist: long CSS smooth scrolls into not-yet-rendered regions get
   cancelled when lazy media loads and shifts the layout mid-flight (first-visit
   nav clicks stall at scrollY 0). After any same-page anchor click, watch the
   target; if the scroll stalls before arriving, re-drive it with scrollIntoView
   (which honours each section's scroll-margin). Aborts on user wheel/touch. */
(function () {
  var timer = null;
  function cancel() { if (timer) { clearInterval(timer); timer = null; } }
  window.addEventListener('wheel', cancel, { passive: true });
  window.addEventListener('touchstart', cancel, { passive: true });
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented) return; /* mobile Build-My-Dome interceptor owns its own scroll */
    var a = e.target.closest && e.target.closest('a[href*="#"]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    var hashIdx = href.indexOf('#');
    var id = href.slice(hashIdx + 1);
    if (!id || id === 'gdx-step-1') return;
    var path = href.slice(0, hashIdx).replace(/[?].*$/, '');
    if (path && path !== '/' && path !== location.pathname) return; /* cross-page nav */
    var el = document.getElementById(id);
    if (!el) return;
    cancel();
    var lastY = -1, stalled = 0, nudges = 0, ticks = 0;
    timer = setInterval(function () {
      ticks++;
      var top = el.getBoundingClientRect().top;
      if (Math.abs(top) < 220 || ticks > 18 || nudges > 3) { cancel(); return; } /* arrived / give up */
      var y = Math.round(window.scrollY);
      if (y === lastY) { stalled++; } else { stalled = 0; lastY = y; }
      if (stalled >= 2) { /* smooth scroll died short of the target - re-drive it */
        stalled = 0; nudges++;
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 250);
  });
})();
